import { Component } from '@angular/core';
import { AutocompleteLineItemComponent } from "../autocomplete-line-item.component";
import { ListOpeCarte } from '@domain/opecarte/list-opecarte';

/**
 * Affiche un élément de liste pour OpeCarte pour l'autocomplete
 */
@Component({
    templateUrl: './ope-carte-line-item.component.html',
    host: { 'data-test-id': 'ope-carte-line-item' },
})
export class OpeCarteLineItemComponent extends AutocompleteLineItemComponent<ListOpeCarte> {

}